export default __webpack_public_path__ + "static/media/english-to-japanese-screenshot-02.db8a2f8a.png";